// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af61b430","505":"0e788410","869":"0aa15906"}[chunkId] + ".chunk.js";
};